import { render, staticRenderFns } from "./create-survey.vue?vue&type=template&id=cf4d7e84&scoped=true&"
import script from "./create-survey.vue?vue&type=script&lang=js&"
export * from "./create-survey.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf4d7e84",
  null
  
)

export default component.exports